const routes = [
  {
    path: "dashboard",
    name: "home1",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/Dashboard.vue"),
	meta: {
		title: 'Latest2'
	}
  },
  {
    path: "dashboard/:user_id",
    name: "dashboard",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/Dashboard.vue"),
    meta: {
		title: 'Latest'
	}
  },
  {
    path: "categories",
    name: "category",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/Categories.vue"),
    meta: {
		title: 'Categories'
	}
  },
  {
    path: "categories/:slug",
    name: "categories",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/Categories.vue"),
    meta: {
		title: "Category"
	}
  },
  {
    path: "post/:post_id",
    name: "post",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/Post.vue"),
    meta: {
		title: "Post"
	}
  },
  {
    path: "post_add",
    name: "post_add_no_cat",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/PostAdd.vue"),
    meta: {
		title: "Add Post"
	}
  },
  {
    path: "post_add/:slug",
    name: "post_add",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/PostAdd.vue"),
    meta: {
		title: "Add Post"
	}
  },
  {
    path: "post_edit/:post_id/:reply_id",
    name: "post_edit",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/PostEdit.vue"),
    meta: {
		title: "Edit Post"
	}
  },
  {
    path: "post_reply/:post_id/:post_type/:reply_id",
    name: "post_reply",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/PostReply.vue"),
    meta: {
		title: "Post Reply"
	}
  },
  {
    path: "search_results",
    name: "search_results",
    component: () => import(/* webpackChunkName: "forum" */"../views/forum/SearchResults.vue"),
    meta: {
		title: "Search Results"
	}
  },
];

export default routes;
